var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["info-box", "info-box-" + _vm.type, { "with-icon": _vm.withIcon }]
    },
    [
      _c(
        "div",
        [_vm.withIcon ? _c("Icon", { attrs: { icon: _vm.icon } }) : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c("div", [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }